import CreateJob from "./jobDetails/CreateJob";
import JobOrderList from "./jobDetails/JobOrderList";
import TaskCreate from "./taskAssigned/TaskCreate";
import TaskView from "./taskAssigned/TaskView";
// import JobWorkingList from "./jobDetails/JobWorkinList";
import JobApprovedList from "./jobDetails/JobApprovedList";
import NoticeList from "./Notices/NoticeList";
import CreateNotice from "./Notices/CreateNotice";
import BookmarkList from "./bookMark/BookmarkList";
import BookMarkCreate from "./bookMark/BookMarkCreate";
import AdsList from "./newsDepart/AdsList";
import AdCreate from "./newsDepart/AdsCreate";
import NewsList from "./newsDepart/NewsList";
import NewsCreate from "./newsDepart/NewsCreate";
// import CandidateReceivedList from "./Vacancy-details/CandidateReceivedList";
// import VacancyPublishedList from "./Vacancy-details/VacancyPublishedList";
// import CreateVacancy from "./Vacancy-details/CreateVacancy";
import PublicDownloadUpload from "./DownloadList/PublicDownloadUpload";
import StaffDownloadUpload from "./DownloadList/StaffDownloadUpload";
import ImpLinkCreate from "./publicSystemManage/ImpLinkCreate";
import ImpLinkList from "./publicSystemManage/ImpLinkList";
import Gallery from "./publicSystemManage/Gallery";
import ServiceList from "./serviceDetails/ServiceList";
import ServiceCreate from "./serviceDetails/ServiceCreate";
import IrdPanSearch from "./irdBlock/IrdPanSearch";
import IrdTaskPage from "./irdBlock/IrdTaskPage";
import IrdHome from "./irdBlock/IrdHome";
import OcrLogin from "./ocrBlock/OcrLogin";
import OcrHome from "./ocrBlock/OcrHome";
import CreateMail from "./webMail/CreateMail";
import ViewMail from "./webMail/ViewMail";
import VatList from "./vatReport/VatList";
import VatCreate from "./vatReport/VatCreate";
import ListReceived from "./createRecieved/ListReceived";
import ReceivedCreate from "./createRecieved/ReceivedCreate";
import ListInvoice from "./Invoice/ListInvoice";
import InvoiceCreate from "./Invoice/InvoiceCreate";
import StaffList from "./staffDetails/StaffList";
import CreateStaff from "./staffDetails/CreateStaff";
// import DayBookCreate from "./dayBook/DaybookCreate";
// import DayBookList from "./dayBook/DayBookList";
import DartaCompleteList from "./CompanyDetails/DartaCompletsList";
import CreateDartaForm from "./CompanyDetails/CreateDartaForm";
import CreatePuForm from "./CompanyDetails/CreatePuForm";
import UserTransfer from "./userBlock/UserTransfer";
import PassiveUser from "./userBlock/PassiveUser";
import ActiveUser from "./userBlock/ActiveUser";
import CreateUser from "./userBlock/CreateUser";
import DirectUserCreate from "./userBlock/DirectUserCreate";
import JobCompletedList from "./jobDetails/JobCompletedList";
import JobPendingList from "./jobDetails/JobPendingList";
import PuList from "./CompanyDetails/PuList";
import CreateGroup from "./groups/CreateGroup";
import ListGroup from "./groups/ListGroup";
import CompanyList from "./CompanyDetails/CompanyList"
import CreatePayment from "./Payment/CreatePayment";
import ListPayment from "./Payment/ListPayment";
import CreateEmployee from "./EmployeeDetail/CreateEmployee";
import ListEmployee from "./EmployeeDetail/ListEmployee";
import AddAboutSection from "./About Us/AddAboutSection";
import AboutList from "./About Us/AboutList";
import TransactionList from "./Transaction/TransactionList";
import TransactionCreate from "./Transaction/TransactionCreate";
import CreateCharge from "./service/CreateCharge";
import ListCharge from "./service/ListCharge";



const sidebar = [
  {
    name: "Task Assigned",
    link: "task-assigned",
    chidren: [
      {
        name: "New Task Create",
        link: "new-task-create",
        model: "Task",
        component: TaskCreate,
      },
      {
        name: "Task Assigned List",
        link: "task-assigned-list",
        model: "Task",
        component: TaskView,
      },
    ],

  },
  {
    name: "Job Working Details",
    link: "job-working-JobDetails",

    chidren: [
      {
        name: "Create New Job",
        link: "create-new-job",
        component: CreateJob,
        model: "Job Order",
      },
      {
        name: "Job Order List With Status",
        link: "job-order-list",
        component: JobOrderList,
        model: "Job Order",
      },
      // {
      //   name: "Job Working List",
      //   link: "job-working-list",
      //   component: JobWorkingList,
      // },
      {
        name: "Job Pending List",
        link: "job-pending-list",
        component: JobPendingList,
        model: "Job Order",
      },
      {
        name: "Job Approved List",
        link: "job-approved-list",
        component: JobApprovedList,
        model: "Job Order",
      }, 
      {
        name: "Job Completed List",
        link: "job-completed-list",
        component: JobCompletedList,
        model: "Job Order",
      },
    ],
  },
  {
    name: "User Block",
    link: "user-block",

    chidren: [
      {
        name: "Create User",
        link: "create-user",
        component: CreateUser,
        model: "User",
      },
      {
        name: "Direct User Create List",
        link: "direct-user-create-list",
        component: DirectUserCreate,
        model: "User",

      },
      {
        name: "Active Users",
        link: "active-users",
        component: ActiveUser,
        model: "User",

      },
      {
        name: "Passive Users",
        link: "passive-users",
        component: PassiveUser,
        model: "User",

      },
      {
        name: "User Transfer",
        link: "user-transfer",
        component: UserTransfer,
        model: "User",

      },
    ],
  },
  {
    name: "Company Details",
    link: "company-details",

    chidren: [
      {
        name: "Company List",
        link: "company-list",
        component: CompanyList,
      },
      {
        name: "Create PU Given Form",
        link: "create-pu-form",
        component: CreatePuForm,
        model: "Pu Given Form",
      },
      {
        name: "PU Given List",
        link: "pu-list",
        component: PuList,
        model: "Pu Given Form",

      },
      {
        name: "Create Darta Complete Form",
        link: "create-darta-form",
        component: CreateDartaForm,
        model : "Registration Completion Form"
      },
      {
        name: "Darta Complete Form List",
        link: "darta-complete-form-list",
        component: DartaCompleteList,
        model : "Registration Completion Form",
      },
    ],
  },
  // {
  //   name: "Day Books",
  //   link: "day-books",
  //   chidren: [
  //     {
  //       name: "New DayBook Create",
  //       link: "new-daybook-create",
  //       component: DayBookCreate,
  //     },
  //     {
  //       name: "Day Book List",
  //       link: "day-book-list",
  //       component: DayBookList,
  //     },
  //   ],
  // },

  {
    name: "Create Group",
    link: "group",
    chidren: [
      {
        name: "Create Group",
        link: "create-group",
        component: CreateGroup,
        model : "Group"
      },
      {
        name: "List Group",
        link: "list-group",
        component: ListGroup,
        model : "Group"
      },
    ],
  },

  {
    name: "Staff Details",
    link: "staff-details",
    chidren: [
      {
        name: "Create Staff",
        link: "create-staff",
        component: CreateStaff,
        model: "User"

      },
      {
        name: "Staff List",
        link: "staff-list",
        component: StaffList,
        model : "User"
      },
    ],
  },
  {
    name: "Invoice",
    link: "invoice",
    chidren: [
      {
        name: "New Invoice Create",
        link: "new-involve-create",
        component: InvoiceCreate,
        model : "Invoice"
      },
      {
        name: "List Invoice",
        link: "list-invoice",
        component: ListInvoice,
        model : "Invoice"
      },
    ],
  },
  {
    name: "Create Received",
    link: "create-received",
    chidren: [
      {
        name: "New Received Create",
        link: "new-received-create",
        component: ReceivedCreate,
        model: "Receipt",
      },
      {
        name: "List Received",
        link: "list-received",
        component: ListReceived,
        model : "Receipt"
      },
    ],
  },
  {
    name: "Vat Report",
    link: "vat-report",
    chidren: [
      {
        name: "New Vat Create",
        link: "new-vat-create",
        component: VatCreate,
        model: "Vat Entry",
      },
      {
        name: "List Vat Report",
        link: "list-vat-report",
        component: VatList,
        model: "Vat Entry",
      },
    ],
  },
  {
    name: "Web Mail",
    link: "web-mail",
    chidren: [
      {
        name: "View Mail",
        link: "view-mail",
        component: ViewMail,
        model : "all"
      },
      {
        name: "Create Mail",
        link: "create-mail",
        component: CreateMail,
        model : "all"
      },
    ],
  },
  {
    name: "OCR Work Block",
    link: "ocr-work-block",
    chidren: [
      {
        name: "Homepage",
        link: "ocr-homepage",
        component: OcrHome,
        model : "all"
      },
      {
        name: "Company Login",
        link: "company-login",
        component: OcrLogin,
        model : "all"
      },
    ],
  },
  {
    name: "IRD Work Block",
    link: "ird-work-block",
    chidren: [
      {
        name: "Homepage",
        link: "ird-homepage",
        component: IrdHome,
        model : "all"
      },
      {
        name: "Tax Payer Portal",
        link: "tax-payer-portal",
        component: IrdTaskPage,
        model : "all"
      },
      {
        name: "Pan Search",
        link: "pan-search",
        component: IrdPanSearch,
        model : "all"
      },
    ],
  },
  {
    name: "Services Details",
    link: "service-details",
    chidren: [
      {
        name: "Create Services",
        link: "../services",
        component: ServiceCreate,
        model : "all"
      },
      {
        name: "Services Details",
        link: "services-details",
        component: ServiceList,
        model : "all"
      },
    ],
  },
  {
    name: "Public System Manage",
    link: "public-system-manage",
    chidren: [
      {
        name: "Gallery",
        link: "gallery-upload",
        component: Gallery,
        model : "Media"
      },
      {
        name: "Create Important Link",
        link: "create-important-link",
        component: ImpLinkCreate,
        model: "Important Link",
      },
      {
        name: "Important Link Details",
        link: "important-link-details",
        component: ImpLinkList,
        model: "Important Link",
      },
    ],
  },
  {
    name: "Download Details",
    link: "downloads-details",
    chidren: [
      {
        name: "Staff Downloads/Upload List",
        link: "staff-download/upload-list",
        component: StaffDownloadUpload,
        model : "all"
      },
      {
        name: "Public Downloads/Upload List",
        link: "public-download/upload-list",
        component: PublicDownloadUpload,
        model : "all"
      },
    ],
  },
  // {
  //   name: "Vacancy Details",
  //   link: "vacancy-details",
  //   chidren: [
  //     {
  //       name: "Create Vacancy",
  //       link: "create-vacancy",
  //       component: CreateVacancy,
  //     },
  //     {
  //       name: "Vacancy Published List",
  //       link: "vacancy-published-list",
  //       component: VacancyPublishedList,
  //     },
  //     {
  //       name: "Candidate Received List",
  //       link: "candidate-received-list",
  //       component: CandidateReceivedList,
  //     },
  //   ],
  // },
  {
    name: "News Depart",
    link: "news-depart",
  
    
    chidren: [
      {
        name: "Create News Post",
        link: "create-news-post",
        component: NewsCreate,
        model: "News"
      },
      {
        name: "Posted News List",
        link: "posted-news-list",
        component: NewsList,
        model :"News"
      },
      {
        name: "Create Ads",
        link: "create-ads",
        component: AdCreate,
        model : "Advertisement"
      },
      {
        name: "View Ads List",
        link: "view-ads-list",
        component: AdsList,
        model : "Advertisement"

      },
    ],

  },
  {
    name: "Bookmarks",
    link: "bookmarks",
    chidren: [
      {
        model: "Bookmark",
        name: "Create Bookmarks",
        link: "create-bookmarks",
        component: BookMarkCreate,
      
      },
      {

        name: "Bookmark List",
        link: "bookmark-list",
        component: BookmarkList,
        model: "Bookmark",

      },
    ],
  },
  {
    name: "Notice Details",
    link: "notice-details",
    chidren: [
      {
        name: "Create notice",
        link: "create-notice",
        component: CreateNotice,
        model : "Notice"
      },
      {
        name: "Notice List",
        link: "notice-list",
        component: NoticeList,
        model : "Notice"
      },
    ],
  },
  {
    name: "Payment Details",
    link: "payment-details",
    chidren: [
      {
        name: "Create Payment",
        link: "create-payment",
        component: CreatePayment,
        model: "Payment Detail",
      },
      {
        name: "Payment List",
        link: "payment-list",
        component: ListPayment,
        model: "Payment Detail",
      },
    ],
  },
  {
    name: "Employee Details",
    link: "employee-details",
    chidren: [
      {
        name: "Create Employee",
        link: "create-employee",
        component: CreateEmployee,
        model: "Public Employee Detail",
      },
      {
        name: "Employee List",
        link: "employee-list",
        component: ListEmployee,
        model: "Public Employee Detail",
      },
    ],
  },
  {
    name: "About Section",
    link: "about-section",
    chidren: [
      {
        name: "Add About Section",
        link: "add-about",
        component: AddAboutSection,
        model: "About Us Description",

      },
      {
        name: "About Section List",
        link: "about-list",
        component: AboutList,
        model: "About Us Description",
      }
    ],
  },
  {
   
    name: "Transaction",
    link: "transaction",
    chidren: [
      {
        name: "List Transaction",
        link: "list-transaction",
        component: TransactionList,
        model: "Transaction",
      },
      {
        name: "Create Transaction",
        link: "create-transaction",
        component: TransactionCreate,
        model: "Transaction",
      },
    ],
  },
  {
    name: "Service Charge",
    link: "service-charge",
    chidren: [
      {
        name: "Create Service Charge",
        link: "create-charge",
        component: CreateCharge,
        "model": "Servicecharge",
      },
      {
        name: "List Service Charge",
        link: "list-charge",
        component: ListCharge,
        "model": "Servicecharge",
      },
    ],
  },


];

export default sidebar;
